import styled from "@emotion/styled";

import { FONT_WEIGHT_SEMI_BOLD, Form, FormRow } from "@skilitics/designer-ui-components";

export const EventForm = styled(Form)`
  ${FormRow}:last-of-type {
    margin-block-end: 0;
  }
`;

export const EventFormRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const EventSpan = styled.span`
  font-weight: ${FONT_WEIGHT_SEMI_BOLD};
`;

export const EventContainer = styled.div`
  position: relative;

  display: flex;
  align-items: center;

  height: 28px;
  width: 100%;

  background-color: ${({ theme }) => theme.surface};

  border-block-end: 1px solid ${({ theme }) => theme.surfaceBack_1};

  font-size: ${({ theme }) => theme.fontSizeSmall};
`;

export const Events = styled.div`
  display: flex;
  flex-direction: column;

  padding-block-start: 10px;

  ${EventContainer}:first-of-type {
    border-block-start: 1px solid ${({ theme }) => theme.surfaceBack_1};
  }
`;

export const EventsHeading = styled.h5`
  margin-block: 0;
  padding-block: 5px;

  font-size: ${({ theme }) => theme.fontSizeSmall};
  font-weight: ${FONT_WEIGHT_SEMI_BOLD};
`;
